import { useState } from 'react'

import { useLocation } from 'react-router'

import { PlanName, PlanRenewalType } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { BillingDetailsCard } from '../Details/BillingDetailsCard'
import { PaymentMethodCard } from '../Details/PaymentMethodCard'
import { UpgradePlanCard } from '../Plans/UpgradePlanCard'
import { planSeatsCapacity } from '../Plans/utils'
import { NumberInput } from './NumberInput'
import { PurchaseCard } from './PurchaseCard'

const planRenewalTypeFromQuery = (
  queryRenewal: string,
): PlanRenewalType | null => {
  switch (queryRenewal as string) {
    case 'month':
      return PlanRenewalType.MONTH
    case 'year':
      return PlanRenewalType.YEAR
    default:
      return null
  }
}
const planNameFromQuery = (queryPlan: string): PlanName | null => {
  switch (queryPlan as string) {
    case 'basic':
      return PlanName.BASIC
    case 'plus':
      return PlanName.PLUS
    case 'premium':
      return PlanName.PREMIUM
    default:
      return null
  }
}

export const PurchasePage = () => {
  const { data: network } = useNetwork()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const plan = planNameFromQuery(params.get('plan'))
  const renewalType = planRenewalTypeFromQuery(params.get('renewalType'))
  const defaultPlanSeatsCapacity = planSeatsCapacity(plan)
  const [seats, setSeats] = useState<number>(
    Math.max(defaultPlanSeatsCapacity, network?.seatsCapacity, 1),
  )

  return (
    <div className="grid grid-cols-3 gap-5">
      <div className="col-span-2 space-y-5">
        <UpgradePlanCard
          planName={plan}
          renewalType={renewalType}
          fullHeight={false}
          showButton={false}
        />
        <Card>
          <Card.Header
            title="Manage seats"
            description={`This plan includes ${defaultPlanSeatsCapacity} staff seats. Add more seats for members that need admin or moderation permissions.`}
          />
          <Card.Content>
            <NumberInput
              value={seats}
              min={defaultPlanSeatsCapacity}
              max={200}
              onChange={setSeats}
            />
          </Card.Content>
        </Card>
        <PaymentMethodCard />
        <BillingDetailsCard />
      </div>
      <div className="col-span-1">
        <PurchaseCard planName={plan} renewalType={renewalType} seats={seats} />
      </div>
    </div>
  )
}
